import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogShellComponent } from '../../blog-shell/blog-shell.component';
import { TranslationSyncService } from '../../../../services/translation-sync.service';
import { BlogEntryBase } from '../../shared/blog-entry-base';

@Component({
  selector: 'app-coolify',
  standalone: true,
  imports: [BlogShellComponent, CommonModule],
  templateUrl: './coolify.component.html',
  styleUrls: ['./coolify.component.css']
})
export class CoolifyComponent extends BlogEntryBase {
  constructor(sync: TranslationSyncService) {
    super(sync);
  }
}
